import { MonthGroupedGrid } from "../../../../components/AdminList";
import type { AttachmentDto } from "../../../../api/types";
import { groupAttachmentsByMonth } from "../../../../logic/attachment-grouping";
import { AttachmentTile } from "./AttachmentTile";

export type AttachmentTileViewProps = {
  attachments: AttachmentDto[];
  onManage: (a: AttachmentDto) => void;
  onCreateInvoice: (a: AttachmentDto) => void;
};

export const AttachmentTileView = ({
  attachments,
  onManage,
  onCreateInvoice,
}: AttachmentTileViewProps) => {
  const groups = groupAttachmentsByMonth(attachments).map((g) => ({
    month: g.month,
    items: g.attachments,
  }));
  return (
    <MonthGroupedGrid
      groups={groups}
      getKey={(a) => a.id}
      renderItem={(a) => (
        <AttachmentTile
          attachment={a}
          onManage={onManage}
          onCreateInvoice={onCreateInvoice}
        />
      )}
    />
  );
};
